import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";
import { ActivityTemplateInterface } from "../../Entity/Entities/Activity/ActivityTemplateInterface";
import { TaskTemplateInterface } from "../../Entity/Entities/Task/TaskTemplateInterface";
import Time from "../../Time/Time";
import { UnitInterface } from "../../Entity/Entities/Unit/UnitInterface";
import { PropertyInterface } from "../../Entity/Entities/Property/PropertyInterface";

class ActivityCreateWillMount extends Middleware implements MiddlewareInterface {
  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    const activityTemplateId = parseInt(this.component.props.params.activityTemplateId, 10);
    const activityTemplate = this.component.props.app.activityTemplates.filter((activityTemplate: ActivityTemplateInterface) => activityTemplate.id === activityTemplateId)[0];
    const propertyId = parseInt(this.component.props.params.propertyId, 10);
    const unitId = parseInt(this.component.props.params.unitId, 10);
    this.component.session = this.component.props.app.session.user;
    this.component.person = this.component.props.app.persons.filter(
      person => person.id === this.component.session.id
    )[0];

    this.component.activityTemplate = activityTemplate;
    this.component.propertyId = propertyId;
    this.component.unitId = unitId;

    if (!activityTemplate) {
      return this.component.redirectBack();
    }

    this.component.props.dispatch({
      type: Constants.GLOBAL_ACTIVITY_CREATE_CLEAR
    });

    let pageParams = {...this.component.props.params};
    pageParams.unitId = parseInt(pageParams.unitId, 10);
    pageParams.propertyId = parseInt(pageParams.propertyId, 10);

    if (!!pageParams.propertyId ) {
      const property: PropertyInterface = this.component.props.properties.byId[pageParams.propertyId];

      this.component.setState({
        selectedEntityForActivity: property,
        ownerId: property && property.company && property.companyId,
        owner: property && property.company
      })
    }

    if (!!pageParams.unitId) {
      const unit: UnitInterface = this.component.props.units.byId[pageParams.unitId];

      this.component.setState({
        selectedEntityForActivity: unit,
        tenant: unit && unit.getActiveContract() && unit.getActiveContract().person,
        tenantId: unit && unit.getActiveContract() && unit.getActiveContract().person && unit.getActiveContract().person.id,
        reporterId: unit && unit.getActiveContract() && unit.getActiveContract().person && unit.getActiveContract().person.id
      })
    }

    const taskTemplates = activityTemplate.taskTemplates
      .reverse()
      .sort((task1, task2) => {
        if (task1.name.toLowerCase() > task2.name.toLowerCase()) {
          return 1;
        }

        if (task1.name.toLowerCase() < task2.name.toLowerCase()) {
          return -1;
        }

        return  0;
      })
      .filter(template => template.removed === false)
      .map((template: TaskTemplateInterface) => {
        return {
          name: template.name,
          details: template.details,
          executorId: template.executorId,
          executionDate: template.daysToExecute !== null ?
            new Date (Time.momentify(new Date()).add(template.daysToExecute, "days").format("YYYY-MM-DD")) : null,
          taskTemplateId: template.id,
          checked: true
        }
      });

    this.component.setState({
      name: activityTemplate.name,
      activeTemplate: taskTemplates.length > 0 ? taskTemplates[0] : null,
      taskTemplates: [...taskTemplates]
    });

    if (Object.keys(this.component.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdReporter = this.component.props.app.savedDataBeforeRedirecting.reporter &&
        this.component.props.app.savedDataBeforeRedirecting.reporter;

      const createdExecutor = this.component.props.app.savedDataBeforeRedirecting.executor &&
        this.component.props.app.savedDataBeforeRedirecting.executor;

      const state = {
        ...this.component.props.app.savedDataBeforeRedirecting.activityCreateDataToBeSaved,
      };

      if (!!createdReporter) {
        state.reporterId = createdReporter.id;
      }

      if (!!createdExecutor && state.activeTemplate) {
        state.activeTemplate.executorId = createdExecutor.id;
      }

      this.component.setState({
        ...state
      });
    }
  }
}

export default new ActivityCreateWillMount();
